import { Component, Output, EventEmitter, OnDestroy, OnInit, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef, ViewChildren, QueryList, HostListener, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NavbarContainerService } from '../services/navbar-container.service';
import { LoggedInUserDto } from '../modals/dashboard/loggedInUserDto';
import { EmployeeProfileDto } from '../modals/dashboard/employeeProfileDto';
import { DashboardInformationDto } from '../modals/dashboard/dashboardInformationDto';
import { MenuDto } from '../modals/dashboard/menuDto';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { LayoutService } from '../services/layout.service';
import { ConfigService } from '../services/config.service';
import { LocalStorageService } from '../services/localstorage.service';
import { CustomizeService } from '../services/customize.service';
import { UserSourceType } from 'app/incomTaxEnums/UserSourceType.enum';
import { DropDown, DropDownValues } from '../modals/DropDownValues';
import { HelperPopUpDto } from '../commonDto/navbarLinks/HelperPopUpDto';
import { SearchScreenDependencyDto } from '../commonDto/navbarLinks/SearchScreenDependencyDto';
import { ConfirmService } from '../services/helperService/confirm.service';
import { GetPermission } from '../baseComponent';

export class SearchItemBar {
  name!: string;
  url!: string;
  icon!: string;
}

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  toggleClass = "ft-maximize";
  logoUrl = 'assets/img/logo.png';
  menuPosition = 'Side';
  isSmallScreen = false;
  protected innerWidth: any;
  searchOpenClass = " ";
  searchBar!: boolean;
  transparentBGClass = " ";
  hideSidebar: boolean = true;
  layoutSub: Subscription;
  configSub!: Subscription | undefined;
  bgColor!: string;
  dashboardUsername!: string;
  selectedMenu = false;
  orgDisplayTitle!: string;
  UserDetail!: LoggedInUserDto;
  organizationID!: number;
  previousOrganization !: number;
  batchTitle!: string;
  batchID!: number;
  employeeProfile!: EmployeeProfileDto
  organizationBatch!: DropDownValues<DropDown[]>[];
  BatchDropdown!: DropDown[];
  UserSourceType = UserSourceType;
  helperPopUp!: HelperPopUpDto;
  helpPopUp!: SafeHtml
  dependencyPopUp!: SearchScreenDependencyDto
  dependencypopUp!: SafeHtml
  DashboardInformation!: DashboardInformationDto;
  listItems: SearchItemBar[] = [];
  MenuData: MenuDto[] = []
  navbarLinkData: { type: string, iconName: string }[] = [
    { type: 'Home', iconName: 'ft-home' },
    { type: 'Dependency', iconName: 'ft-link-2' },
    { type: 'Helper', iconName: 'fa fa-solid fa-question' },
    { type: 'Logout', iconName: 'ft-power' },
  ]

  @ViewChild('search') searchElement!: ElementRef;
  @ViewChild('DependencyModel') DependencyModel!: TemplateRef<any>;
  @ViewChild('HelperModel') HelperModel!: TemplateRef<any>;
  @ViewChildren('searchResults') searchResults!: QueryList<any>;
  @Output() toggleHideSidebar = new EventEmitter<Object>();
  @Output() searchTextEmpty = new EventEmitter<boolean>();

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        return term?.length < 2 ? [] : this.listItems.filter(v => v.name.toLowerCase().startsWith(term.toLowerCase()));
      })
    )

  control = new FormControl()
  public config: any = {};

  constructor(
    public translate: TranslateService,
    private layoutService: LayoutService,
    private router: Router,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private customizeService: CustomizeService,
    private localStorageService: LocalStorageService,
    private navbarContainerServices: NavbarContainerService,
    private DomSanitizer: DomSanitizer,
    private confirmService: ConfirmService,


  ) {
    const browserLang: string = translate.getBrowserLang() ?? 'en-in';
    translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : "en");
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.layoutSub = layoutService.toggleSidebar$.subscribe(
      isShow => {
        this.hideSidebar = !isShow;
      });
  }

  ngOnInit() {
    this.UserDetail = this.localStorageService.getLocalData('UserDetail')
    this.orgDisplayTitle = this.UserDetail?.orgDisplayTitle;
    this.dashboardUsername = this.UserDetail?.employeeFullName;
    this.batchTitle = this.UserDetail?.batchTitle;

    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    }
    else {
      this.isSmallScreen = false;
    }
    this.searchBar = false
  }

  searchUrlandName() {
    let SideBarMenulist = this.localStorageService.getLocalData('SideBarMenulist')
    if (SideBarMenulist && this.listItems?.length == 0) {
      this.MenuData = SideBarMenulist
      this.MenuData?.forEach((e) => {

        this.listItems.push({ "url": e.pageURL, "name": e.menuTitle, "icon": e.icon ? e.icon : 'ft-arrow-right' });
      })
    }
    //TODO: to get list of menu for translation help
    const translatedJSON: string[] = [];
    for (const key in this.listItems) {
      if (this.listItems.hasOwnProperty(key)) {
        const name = this.listItems[key].name;
        translatedJSON.push(name);
      }
    }
  }

  UpdateAcademicOrganization() {
    let headers = new HttpHeaders()
    let body = {
      'orgId': this.organizationID,
      'batchId': this.batchID
    };
    this.navbarContainerServices.UpdateAcademicBatchOrganization(JSON.stringify(body), headers).subscribe(() => {
      window.location.reload();
    });
  }

  fnLink(type: string) {
    switch (type) {
      case 'Home':
        this.router.navigate(['Dashboard'])
        break;
      case 'Helper':
        this.modalService.open(this.HelperModel, { ariaLabelledBy: 'modal-badic-title', size: 'lg' });
        this.helper()
        break;
      case 'Dependency':
        this.modalService.open(this.DependencyModel, { ariaLabelledBy: 'modal-badic-title', size: 'lg' });
        this.dependency()
        break;
      case 'Logout':
          this.logOff()
        break;
    }
  }

  logOff() {
    let headers = new HttpHeaders();
    this.navbarContainerServices.Logoff('', headers).subscribe(() => {
      let valueToRetain: string[] = [];
      valueToRetain.push('OrgGroupId', 'imgChanger', 'ColorChanger', 'BtnColorChanger', 'LanguageTranslationData', 'RedirectUrl');
      this.localStorageService.clearLocalData(valueToRetain);
      GetPermission.clear();
      window.location.href = this.localStorageService.getLocalDataStr('RedirectUrl')
    });
  }

  helper() {
    let ScreenId = this.localStorageService.getLocalData('screenId');
    let params = new HttpParams().set('ScreenId', ScreenId)
    this.navbarContainerServices.GetHelperPopUp(params).subscribe(response => {
      this.helperPopUp = response
      this.helpPopUp = this.DomSanitizer.bypassSecurityTrustHtml(this.helperPopUp.result);
    })
  }


  dependency() {
    let ScreenId = this.localStorageService.getLocalData('screenId');
    let params = new HttpParams().set('ScreenId', ScreenId)
    this.navbarContainerServices.GetSearchScreenDependency(params).subscribe(response => {
      this.dependencyPopUp = response
      this.dependencypopUp = this.DomSanitizer.bypassSecurityTrustHtml(this.dependencyPopUp.screenDependency);
    })
  }

  getAndSetLocalData() {
    this.previousOrganization = this.organizationID;
    this.employeeProfile = this.localStorageService.getLocalData('employeeProfile')
    this.employeeProfile.orgId = Number(this.organizationID)
    this.employeeProfile.batchId = Number(this.batchID)
    this.employeeProfile.orgDisplayTitle = String(this.orgDisplayTitle)
    this.employeeProfile.batchTitle = String(this.batchTitle)
    this.localStorageService.setLocalData('employeeProfile', this.employeeProfile)
    this.UserDetail.orgId = Number(this.organizationID)
    this.UserDetail.batchId = Number(this.batchID)
    this.UserDetail.orgDisplayTitle = String(this.orgDisplayTitle)
    this.UserDetail.batchTitle = String(this.batchTitle)
    this.localStorageService.setLocalData('UserDetail', this.UserDetail);
  }

  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();
      this.cdr.detectChanges()
    })
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = event.target.innerWidth;
    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    }
    else {
      this.isSmallScreen = false;
    }
  }

  loadLayout() {
    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() != " ") {
      this.menuPosition = this.config.layout.menuPosition;
    }

    if (this.config.layout.variant === "Light") {
      this.logoUrl = 'assets/ContentTemplates/BrandLogo.png';
    }
    else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (!this.config.layout.sidebar.backgroundColor) {
      this.bgColor = this.customizeService.light_dark_colors[7].code;
    } else {
      this.bgColor = this.config.layout.sidebar.backgroundColor;
    }

    if (this.config.layout.variant === "Transparent") {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    }
    else {
      this.transparentBGClass = " ";
    }

  }

  onSearchKey(event: any) {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.add('first-active-item');
    }

    if (event.target.value === " ") {
      this.searchTextEmpty.emit(true);
    }
    else {
      this.searchTextEmpty.emit(false);
    }
  }

  removeActiveClass() {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.remove('first-active-item');
    }
  }

  onEscEvent() {
    this.control.setValue("");
    this.searchOpenClass = '';
    this.searchTextEmpty.emit(true);
  }

  onEnter() {
    if (this.searchResults && this.searchResults.length > 0) {
      let url = this.searchResults.first.url;
      if (url && url != '') {
        this.control.setValue("");
        this.searchOpenClass = '';
        this.router.navigate([url]);
        this.searchTextEmpty.emit(true);
      }
    }
    if (this.selectedMenu) {
      this.selectedMenu = false;
      if (this.control.value != '') {
        let url = this.control.value.url;
        if (url && url != '') {
          this.control.setValue("");
          this.searchOpenClass = '';
          if (url.indexOf('') >= 0) { // in case of angular page, navigate to desired component
            this.router.navigate([url.split('').length > 0 ? url.split('')[1] : '']);
            this.searchTextEmpty.emit(true);
          } else {
            window.location.href = url;
            this.searchTextEmpty.emit(true);
          }
        }
      }
    } else {
      this.selectedMenu = true;
    }
  }

  redirectTo(value: any) {
    this.router.navigate([value]);
    this.searchTextEmpty.emit(true);
    document.getElementById('cross')?.click()
  }

  ToggleClass() {
    if (this.toggleClass === "ft-maximize") {
      this.toggleClass = "ft-minimize";
    } else {
      this.toggleClass = "ft-maximize";
    }
  }

  toggleSearchOpenClass(display: any) {
    this.searchBar = !this.searchBar
    this.control.setValue("");
    if (display) {
      this.searchOpenClass = 'open';
      setTimeout(() => {
        this.searchElement?.nativeElement?.focus();
        document.getElementById('searchMenu')?.focus();
      }, 0);
    }
    else {
      this.searchOpenClass = '';
    }
    this.searchTextEmpty.emit(true);
  }

  toggleSidebar() {
    this.layoutService.toggleSidebarSmallScreen(this.hideSidebar);
  }
}
